import { blackOrange, textMuted } from '@/theme/colors'
import { fontBody, fontDisplay } from '@/theme/fonts'
import styled from 'styled-components'

export const HeadingBlock = styled.div`
	min-width: 0;
`

/* Explicit colors: the GlobalStyle h1/p element rules must never win here. */
export const HeadingTitle = styled.h1`
	font-family: ${fontDisplay};
	font-weight: 800;
	font-size: 28px;
	letter-spacing: -0.01em;
	color: ${blackOrange};
	margin: 0;

	@media (max-width: 600px) {
		font-size: 24px;
	}
`

export const HeadingSubtitle = styled.p`
	font-family: ${fontBody};
	font-size: 15px;
	color: ${textMuted};
	margin: 4px 0 0;
`
